<template>
    <modal @close="editAdminSettingsCancelClick" class="edit-modal" hideFooter id="edit-admin-settings">
        <div class="td-edit-container one-step">
            <div class="pagination">
                <div class="form-name">
                    <h3>Edit Admin Settings</h3>
                    <ul>
                        <li class="py-1">Only one user on the account can be the Primary Contact</li>
                        <li class="py-1">Multiple users on the account can be the Billing Contact</li>
                    </ul>

                    <div v-if="userProfile.isPrimary === true">
                        <p>This user is the Primary User on the account and there must always be a primary user on the account.</p>
                        <p>To change the Primary User you need to promote a different user to Primary User.</p>
                    </div>
                </div>
            </div>
            <div class="edit-pages">
                <form>
                    <h3>Edit Admin Settings</h3>
                    <div class="md-col-2">
                        <div class="column">

                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">Status:</label> <span v-if="userProfile.status == UserStatus.Purge">Purge</span>
                                <select v-if="userProfile.status != UserStatus.Purge" v-model="updateModel.status" required>
                                    <option :value="UserStatus.Active"> {{ statusDisplay(UserStatus.Active) }} </option>
                                    <option :value="UserStatus.Inactive"> {{ statusDisplay(UserStatus.Inactive) }} </option>
                                    <option :value="UserStatus.New"> {{ statusDisplay(UserStatus.New) }} </option>
                                    <option :value="UserStatus.Purge"> {{ statusDisplay(UserStatus.Purge) }} </option>
                                </select>
                            </div>

                            <div class="mt-3">
                                <label class="td-checkbox-label td-text-bold">
                                    Primary Contact
                                    <input name="primaryContact" type="checkbox" v-model="updateModel.isPrimary" :checked="updateModel.isPrimary === true" :disabled="updateModel.isPrimary === true" />
                                    <span></span>
                                </label>
                            </div>

                            <div class="mt-3">
                                <label class="td-checkbox-label td-text-bold">
                                    Billing Contact
                                    <input name="billingContact" type="checkbox" v-model="updateModel.isBilling" :checked="updateModel.isBilling === true" />
                                    <span></span>
                                </label>
                            </div>

                            <div class="mt-3">
                                <label class="td-checkbox-label td-text-bold">
                                    Allowed to Rate Vendors
                                    <input name="allowedToRateVendors" type="checkbox" v-model="updateModel.suppressRatings" :checked="getAllowedToRateVendors(userProfile)" />
                                    <span></span>
                                </label>
                            </div>
                        </div>
                        <div class="column">

                        </div>
                    </div>
                </form>

                <div class="actions">
                    <div>
                        <button class="td-btn primary-outlined" @click="editAdminSettingsCancelClick">Cancel</button>
                    </div>
                    <div class="save-btn">
                        <button class="td-btn btn primary" @click="editAdminSettingsSaveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Save</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import script from './EditAdminSettings';
    export default script;
</script>
<style lang="less">
    @import './EditAdminSettings.less';
</style>